<template>
  <div class="ds-control ds-selectpermissions">
    <div class="left">
      <div v-if="showRole" class="header" ref="header" :class="[tabIndex ? 'tabIndex1' : 'tabIndex0']">
        <span @click="tabIndex = 0">
          <i class="iconfont icon-icon_user_bm"></i>
          <span>按组织机构选</span>
        </span>
        <span @click="tabIndex = 1">
          <i class="iconfont icon-zhuhutiaocha"></i>
          <span>按部门角色选</span>
        </span>
      </div>
      <div class="content" ref="content" :style="{ height: contentHeight }">
        <template v-if="inited">
          <div class="tabIndex0" v-show="!tabIndex">
            <!-- 按组织机构选 -->
            <org-box ref="orgBox" />
          </div>
          <!-- 按部门角色选 -->
          <div class="tabIndex1" v-if="showRole" v-show="tabIndex">
            <org-box ref="roleOrgBox" :is-role="true" />
            <role-tree ref="roleTree" />
          </div>
        </template>
      </div>
    </div>
    <result-list :list="resultLists" ref="resultList"></result-list>

    <!-- 角色选定悬浮按钮 -->
    <div class="roleBtn" ref="roleBtn" :style="{ right: rightCss }" v-show="tabIndex" @click="setRoleResultList">
      <span>选</span>
      <span>择</span>
      <i class="el-icon-d-arrow-right"></i>
    </div>
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfSelectPermissions",
  ctrlCaption: "权限选择器",
  mixins: [$mixins.control, $mixins.dataResult],
  design: {
    isMask: true, //调试模式为false,调试完后会改为true
    fit: true
  },
  components: {
    orgBox: () => import(/* webpackChunkName: "platform_pc_other" */ "./orgBox.vue"),
    roleTree: () => import(/* webpackChunkName: "platform_pc_other" */ "./roleTree.vue"),
    resultList: () => import(/* webpackChunkName: "platform_pc_other" */ "./resultList.vue")
  },
  props: {
    orgHttpUrl: {
      // 自定义得组织机构请求地址
      type: String,
      default: "/dp/oua/finOrgByPid"
    },
    webRootValue: {
      // 自定义得根目录value
      type: String,
      default: null
    },
    webRootText: {
      // 自定义得根目录text
      type: String,
      default: null
    }
  },
  provide() {
    return {
      $seletPermissions: this
    };
  },
  data() {
    return {
      tabIndex: 0,
      contentHeight: 0,
      resultLists: [],
      roleOrg: [],
      roleTree: [],
      rightCss: "280px",
      defaultSelectValue: [],
      inited: false,
      showRole: this.isDesign || this.$eval("@[pri('_data_permission_scope_role_choose')]")
    };
  },
  created() {
    if (this.isDesign) return;
    if (this.$listeners.setDefaultSelect) {
      //自定义二开设置默认选中数据
      this.$dispatch("setDefaultSelect", this.initDefaultSelect);
    } else {
      this.initDefaultSelect(this.$vm?.$attrs?.selectValue);
    }
  },
  methods: {
    initDefaultSelect(list) {
      _.forEach(list, (item) => {
        let value = item.value,
          name = item.text,
          ids = value.split("_"),
          obj = {};
        if (ids?.[0].includes("2")) {
          // 角色
          obj = {
            id: value,
            name: name,
            isRole: true,
            isDefaultSelect: true
          };
        } else if (ids.length == 2) {
          if (ids?.[0] !== "1") {
            // 部门
            obj["valueType"] = "dept";
            obj["config_includeChild"] = ids?.[0] === "A0";
          }
          obj["id"] = ids?.[1];
          obj["name"] = name;
          this.defaultSelectValue.push(obj);
        }
        obj["isDefaultSelect"] = true;
        this.resultLists.push(obj);
      });
      this.inited = true;
    },
    resize() {
      this.getContentHeight();
      this.$refs?.orgBox?.resize?.();
      this.$refs?.roleOrgBox?.resize?.();
      this.$refs?.roleTree?.resize?.();
      if (this?.$refs?.resultList) {
        this.rightCss = this?.$refs?.resultList.$el.clientWidth + "px";
      }
    },
    getContentHeight() {
      if (this.$refs.content) {
        this.contentHeight = `calc(100% - ${this?.$refs?.header?.clientHeight || 0}px)`;
      }
    },
    changeResult(item) {
      let checked = item.config_checked;
      let index = -1;
      _.forEach(this.resultLists, (li, i) => {
        if (item.id == li.id) {
          index = i;
        }
      });
      if (checked && index == -1) {
        // 新
        this.resultLists.push(item);
        this.resultLists = _.unionBy(this.resultLists, "id");
      } else if (!checked && index !== -1) {
        this.resultLists.splice(index, 1);
      }
    },
    changeRoleOrg(item) {
      let checked = item.config_checked;
      let index = -1;
      _.forEach(this.roleOrg, (li, i) => {
        if (item.id == li.id) {
          index = i;
        }
      });
      if (checked && index == -1) {
        // 新
        this.roleOrg.push(item);
      } else if (!checked && index !== -1) {
        this.roleOrg.splice(index, 1);
      }
    },
    setRoleResultList() {
      if (this.roleOrg.length == 0) {
        dsf.layer.message("请选择部门", false);
        return;
      }
      let roleData = this.$refs.roleTree.getResult();
      if (roleData.length == 0) {
        dsf.layer.message("请选择角色", false);
        return;
      }
      _.forEachRight(this.roleOrg, (org) => {
        _.forEachRight(roleData, (role) => {
          let id = "";
          if (org.config_includeChild) {
            id = "21_";
          } else {
            id = "2_";
          }
          id += org.id;
          if (role.type_value === "role") {
            id += "_" + role._id;
            this.resultLists.push({
              id: id,
              name: org.name + "-" + role._name,
              org: dsf.mix({}, org),
              role: dsf.mix({}, role),
              isRole: true
            });
            this.$refs.roleTree.clearResult([role]);
          }
        });
        org.config_includeChild = false;
        org.config_checked = false;
      });
      this.resultLists = _.unionBy(this.resultLists, "id");
      this.roleOrg = [];
    },
    getReturnValue() {
      let lists = [];
      if (!this?.resultLists?.length) {
        dsf.layer.message("请选择权限", false);
        return false;
      } else {
        _.forEach(_.unionBy(this.resultLists, "id"), (item) => {
          let id = item.id;
          let name = item.name;
          if (!item.isDefaultSelect) {
            if (!item.isRole) {
              /**
                 * （开头：0_[id] 指定部门
                    A0_[id]指定部门并包含下级部门
                    2_[id] 指定的当前部门+指定角色ID
                    1_[id]指定用户
                    21_[id]指定部门(包含下级部门)+指定角色ID）
                 */
              if (item.valueType === "dept") {
                if (item.config_includeChild) {
                  id = "A0_" + id;
                  name += "（包含下级）";
                } else {
                  id = "0_" + id;
                }
              } else {
                id = "1_" + id;
              }
            } else if (item.org.config_includeChild) {
              name = name.replace("-", "（包含下级）-");
            }
          }
          lists.push({
            text: name,
            value: id,
            ...item
          });
        });
        return lists;
      }
    }
  }
});
</script>
<style lang="scss">
@import "_platform/assets/styles/pc/bhc/other/selectpermissions.scss";
</style>
